import React, { PropsWithChildren, ReactElement, useContext } from 'react';

export interface ImageMapBrazeContextValue {
  /** 유저 로그인 유무 */
  isLoggedIn?: boolean;
  /**
   * 알람 신청 click 시 발생하는 event 입니다.
   * @params customEventName braze 로깅을 위한 name
   */
  onClick?: (customEventName: string) => Promise<void> | void;
  /**
   * 비로그인 상태일 때 로그인으로 보내도록 합니다.
   */
  onSignin?: () => Promise<void> | void;
}

const ImageMapBrazeContext = React.createContext<ImageMapBrazeContextValue>({});
export const useImageMapBrazeContext = (): ImageMapBrazeContextValue => useContext(ImageMapBrazeContext);

export function ImageMapBrazeContextProvider({
  children,
  value = {},
}: PropsWithChildren<{ value?: ImageMapBrazeContextValue }>): ReactElement {
  return (
    <ImageMapBrazeContext.Provider value={value}>
      { children }
    </ImageMapBrazeContext.Provider>
  );
}
